import type { TFunction } from '~/core/i18n'
import type { TvCategoryEx } from '~/entities/epg/categories'

import { produce } from 'immer'
import { CategoryType } from '~/entities/epg/categories'

export const translateCategory = (t: TFunction) => (category: TvCategoryEx) =>
  produce(category, (draft) => {
    if (draft.type === CategoryType.Favorite) {
      draft.name = t('favorites')
    } else if (draft.type === CategoryType.All) {
      draft.name = t('all')
    } else if (draft.type === CategoryType.Featured) {
      draft.name = t('featured')
    }
  })
